import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer-main-v9">
      <div className="footer-container-v9">
        {/* Logo & About */}
        <div className="footer-column-v9 footer-about-v9">
          <h2 className="footer-logo-v9" onClick={() => navigate("/")}>V9 PrimeForce</h2>
          <p className="footer-text-v9">
            We provide custom solutions tailored to your business needs. Let’s build something great together.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-column-v9 footer-links-v9">
          <h4 className="footer-heading-v9">Quick Links</h4>
          <ul>
            <li onClick={() => navigate("/")}>Home</li>
            <li onClick={() => navigate("/about")}>About</li>
            <li onClick={() => navigate("/enquiry")}>Enquiry</li>
            <li onClick={() => navigate("/contact")}>Contact</li>
            <li onClick={() => navigate("/Terms-and-conditions")}>Terms and Conditions</li>
            <li onClick={() => navigate("/privacy-policy")}>Privacy Policy</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-column-v9 footer-contact-v9">
          <h4 className="footer-heading-v9">Contact</h4>
          <p>Email: info@v9primeforce.com</p>
          <p>Phone: 9967680119 / 7208328645</p>
          <p>Address: Joshi Associate / 002 AANGHI CHS Near union bank Mira Bhayandar Road Mira Road east Dist thane 401107</p>
        </div>

        {/* Social Icons */}
        <div className="footer-column-v9 footer-social-v9">
          <h4 className="footer-heading-v9">Follow Us</h4>
          <div className="footer-icons-v9">
            <a href="#"><i className="fab fa-facebook-f"></i></a>
            <a href="#"><i className="fab fa-twitter"></i></a>
            <a href="#"><i className="fab fa-instagram"></i></a>
            <a href="#"><i className="fab fa-linkedin-in"></i></a>
          </div>
        </div>
      </div>

      {/* Bottom Text */}
      <div className="footer-bottom-v9">
        <p>&copy; {new Date().getFullYear()}, <a href="https://100billiontech.com/ownership" target="_blank"
          rel="noreferrer">Copy-rights reserved</a>. Designed by <a href="https://100billiontech.com/" target="_blank"
            rel="noreferrer">100billion Tech</a></p>
      </div>
    </footer>
  );
};

export default Footer;
